var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 8.50961 15.5865 8.92308 15.0769 8.92308H8.92308V15.0769C8.92308 15.5865 8.50961 16 8 16C7.49038 16 7.07692 15.5865 7.07692 15.0769V8.92308H0.923077C0.413462 8.92308 0 8.50961 0 8C0 7.49038 0.413462 7.07692 0.923077 7.07692H7.07692V0.923077C7.07692 0.413462 7.49038 0 8 0C8.50961 0 8.92308 0.413462 8.92308 0.923077V7.07692H15.0769C15.5865 7.07692 16 7.49038 16 8Z",
    fill: "#F2F5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/plus_white.18da9f68d5ade5f26c9d5fdb1eaf433f.svg";
export { ForwardRef as ReactComponent };